import { useTranslation } from "react-i18next";

import { useConfiguration } from "@/api/configuration";
import { useDashboardSummary } from "@/api/dashboard";
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  formatCurrency,
  formatNumber,
  formatPercent,
} from "@/utils/formatters";

import { StockValueCard } from "./StockValueCard";

export default function Dashboard() {
  const { t } = useTranslation();
  const { data: summary } = useDashboardSummary();
  const { data: config } = useConfiguration();
  const currency = config?.currencyCode ?? "EUR";
  const turnover = summary?.stockTurnover;
  const demand = summary?.recentDemand;

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Card>
          <CardHeader>
            <CardDescription>
              {t("dashboard.kpi.stockTurnover")}
            </CardDescription>
            <CardTitle className="text-2xl tabular-nums">
              {turnover?.turnover != null
                ? `${formatNumber(turnover.turnover)}×`
                : "—"}
            </CardTitle>
          </CardHeader>
          {turnover?.daysOnHand != null && (
            <CardFooter className="text-muted-foreground text-sm">
              {t("dashboard.kpi.daysOnHand", {
                days: formatNumber(turnover.daysOnHand),
              })}
            </CardFooter>
          )}
        </Card>
        <Card>
          <CardHeader>
            <CardDescription>{t("dashboard.kpi.recentDemand")}</CardDescription>
            <CardTitle className="text-2xl tabular-nums">
              {demand
                ? formatCurrency(demand.value, currency, {
                    maximumFractionDigits: 0,
                  })
                : "—"}
            </CardTitle>
          </CardHeader>
          {demand?.deltaPct != null && (
            <CardFooter className="text-muted-foreground text-sm">
              {t("dashboard.kpi.demandDelta", {
                delta: `${demand.deltaPct >= 0 ? "+" : ""}${formatPercent(demand.deltaPct)}`,
              })}
            </CardFooter>
          )}
        </Card>
      </div>
      <StockValueCard />
    </div>
  );
}
